import React, { useState } from "react";
import {
  Modal,
  Card,
  CardContent,
  Button,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { styleCertificate } from "../styleCertificate";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SearchEmployeeContract from "./searchEmployeeContract";
import utils from "../../../utils/utils";
import {
  generateCertificate,
  getContractByEmployee,
  getRepresentationExpense,
} from "../../../actions/employee-action";
import Scrollbars from "react-custom-scrollbars";
import DetailContracts from "./detailContracts";
import Search from "../../../images/icons/search.svg";
import { styles } from "../../styles";
import { REQUIRED_MESSAGE } from "../../../constants";
import { downloadPDF } from "../../../utils/functionsUtils";
import ModalRepresentativesExpenses from "./modalAddRepresentationExpenses";
import ModalConfirmWithValue from "./modalConfirmWithValue";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const defaultValue = {
  linkageType: "",
  initDate: null,
  endDate: null,
};

const GenerateCertificate = ({
  openCard,
  closeModalCard,
  maestras,
  idEmployee,
  setMessage,
  message,
  returnMessage,
  returnCertificate,
  certicateId,
}) => {
  const classes = styleCertificate();
  const classe = styles();
  const [modalStyle] = useState(getModalStyle);
  var currentDate = new Date();
  const [minDate, setMinDate] = useState(null);
  const [maxInitDate, setMaxInitDate] = useState(
    utils.getFormattedDateMMddyyyy(currentDate, ".")
  );
  const [contracts, setContracts] = useState([]);
  const [bindingType, setBindingType] = useState("");
  const [contractIdList, setContractIdList] = useState([]);
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const [openModalRepresentatives, setOpenModalRepresentatives] =
    useState(false);
  const [confirm, setConfirm] = useState({
    open: false,
    handleClickOut: () => {},
    handleClick: () => {},
  });
  let salario = null;

  const schema = yup.object().shape({
    linkageType: yup.string().nullable().required(REQUIRED_MESSAGE),
    initDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (initDate) => initDate && initDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    endDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (endDate) => endDate && endDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
  });

  const { register, handleSubmit, setValue, control, errors, getValues } =
    useForm({
      resolver: yupResolver(schema),
      defaultValue,
      mode: "all",
      reValidateMode: "onChange",
    });

  const cleanForm = () => {
    setValue("linkageType", "");
    setValue("initDate", null);
    setValue("endDate", null);
    setMaxInitDate(new Date());
    setMinDate(null);
    setContracts([]);
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const onSubmitSearch = async (data) => {
    setBindingType(data.linkageType);
    const filters = {
      initContractDate: data.initDate ? data.initDate : null,
      endContractDate: data.endDate ? data.endDate : null,
    };
    const response = await getContractByEmployee(
      idEmployee,
      data.linkageType,
      filters
    );
    if (response?.status === 200 || response?.status === 201) {
      const data = response?.data.map((x) => {
        const contract = { ...x, creationDate: new Date(x?.creationDate) };
        return contract;
      });
      const result = data.sort((a, b) =>
        a.creationDate < b.creationDate ? 1 : -1
      );
      setContracts(result);
    } else {
      setContracts([]);
    }
  };

  const handleClickGoBack = () => {
    cleanForm();
    closeModalCard();
    setBindingType("");
    setContractIdList([]);
    handleClickClose();
    returnCertificate(certicateId);
    setOpenModalRepresentatives(false);
  };

  const askBySendData = () => {
    if (contractIdList?.length === 0 || contractIdList === undefined) {
      const msj =
        "Por favor seleccione algún registro para poder generar su certificado";
      returnMessage(msj, "WARNING", handleClickClose);
      return;
    }
    if (bindingType === "CONTRACTOR") {
      addValuePaidContractor();
    } else {
      objectBySend();
    }
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const addValuePaidContractor = () => {
    setConfirm(() => ({
      open: true,
      handleClick: (salary) => { setSalaryToContractor(salary) },
      handleClickOut: closeModal,
    }));
  };

  const setSalaryToContractor = (salary) => {
    salario = salary;
    objectBySend();
  };

  const objectBySend = () => {
    setMessage({
      description: "¿Está seguro que desea generar certificado laboral?",
      textButtonSubmit: "Guardar",
      handleClick: () => handleClickSendData(),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  const handleClickSendData = async () => {
    const idContract = contractIdList[0];
    const response = await getRepresentationExpense(idContract);
    const newData = {
      bindingType: bindingType,
      contractIdList: contractIdList,
      representationExpensesIsEnabled: false,
      valuePaidContractor: bindingType === "PAYROLL" ? 0 : salario,
    };
    if (response?.data?.length > 0 && bindingType === "PAYROLL") {
      setOpenModalRepresentatives(true);
    } else {
      handleClickSendDatasss(newData);
    }
  };

  const handleClickWithExpenses = (type) => {
    const newData = {
      bindingType: bindingType,
      contractIdList: contractIdList,
      representationExpensesIsEnabled: type === "yes" ? true : false,
      valuePaidContractor: bindingType === "PAYROLL" ? 0 : salario,
    };
    handleClickSendDatasss(newData);
  };

  const handleClickSendDatasss = async (data) => {
    setIsDisabledBtn(true);
    setMessage({ ...message, open: false });
    const response = await generateCertificate(idEmployee, data);
    if (response?.status === 200 || response?.status === 201) {
      const msj = "El certificado laboral se ha generado de manera exitosa";
      returnMessage(msj, "SUCCESS", handleClickGoBack);
      const pdf = response?.data?.data;
      downloadPDF(pdf, "certificado laboral.pdf");
      setIsDisabledBtn(false);
    } else if (response?.status > 399) {
      const msj = response?.data?.detail
        ? response?.data?.detail
        : response?.data?.error;
      returnMessage(msj, "WARNING", handleClickClose);
      setIsDisabledBtn(false);
    } else {
      const msj =
        "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      returnMessage(msj, "WARNING", handleClickClose);
      setIsDisabledBtn(false);
    }
  };

  const handleChangeChecked = (e) => {
    if (e.target.checked === true) {
      if (bindingType === "PAYROLL") {
        setContractIdList([e.target.value]);
      } else {
        setContractIdList([...contractIdList, e.target.value]);
      }
    } else {
      const newList = contractIdList?.filter((x) => x !== e.target.value);
      setContractIdList(newList);
    }
  };

  const isSelectedCheck = (id) => {
    const selected = contractIdList?.find((x) => x === id) ?? false;
    return selected;
  };

  const handleClickCloseExpensives = () => {
    setOpenModalRepresentatives(false);
    handleClickClose();
  };

  const bodyModal = (
    <div style={modalStyle} className={classes.contModalDownload}>
      <Card className={classes.card} elevation={0}>
        <CardContent className={classes.bodyModal}>
          <div className={classes.contAccordion}>
            <p style={{ textAlign: "center", fontSize: 20 }}>
              Generar certificado laboral
            </p>

            <SearchEmployeeContract
              handleSubmit={handleSubmit}
              onSubmit={onSubmitSearch}
              errors={errors}
              control={control}
              register={register}
              cleanForm={cleanForm}
              maestras={maestras}
              getValues={getValues}
              setMaxInitDate={setMaxInitDate}
              setMinDate={setMinDate}
              minDate={minDate}
              maxInitDate={maxInitDate}
              currentDate={currentDate}
            />

            <div className={classes.contAccordion}>
              <Paper elevation={0} className={classes.paperdos}>
                <Scrollbars className={classes.Scrollbars}>
                  {contracts?.length > 0 ? (
                    contracts?.map((resp) => (
                      <DetailContracts
                        data={resp}
                        handleChangeChecked={handleChangeChecked}
                        isSelectedCheck={isSelectedCheck}
                      />
                    ))
                  ) : (
                    <React.Fragment>
                      <div className={classe.messageSearch}>
                        <img src={Search} alt="" />
                        <Typography
                          style={{ paddingTop: "20px", paddingLeft: "20px" }}
                        >
                          No se encontraron registros que coincidan con el
                          filtro de búsqueda aplicado
                        </Typography>
                      </div>
                    </React.Fragment>
                  )}
                </Scrollbars>
              </Paper>
            </div>

            <Grid className={classes.contBtnSubmit}>
              <Button
                variant="outlined"
                style={{ backgroundColor: "transparent", color: "#7EBDCE" }}
                onClick={handleClickGoBack}
              >
                Cancelar
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                className={classes.buttonContinue}
                onClick={askBySendData}
                disabled={isDisabledBtn}
              >
                Aceptar
              </Button>
            </Grid>
          </div>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div>
      <Modal open={openCard}>{bodyModal}</Modal>
      <ModalRepresentativesExpenses
        open={openModalRepresentatives}
        handleClickWithExpenses={handleClickWithExpenses}
        handleClickCloseExpensives={handleClickCloseExpensives}
      />
      <ModalConfirmWithValue
        open={confirm.open}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
      />
    </div>
  );
};

export default GenerateCertificate;
